import React, { createContext, useContext, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { cadastroAPI } from '../services/api';
import { useTheme } from './ThemeContext';

const CadastroContext = createContext();
export const useCadastro = () => useContext(CadastroContext);

export const CadastroProvider = ({ children }) => {
  const { darkMode } = useTheme();
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ cpf_cnpj: '', endereco: '', cidade: '', estado: '', cep: '' });
  const [saving, setSaving] = useState(false);
  const [camposFaltando, setCamposFaltando] = useState([]);

  const verificarEAbrir = useCallback(async (clienteId) => {
    try {
      const res = await cadastroAPI.verificar(clienteId);
      const campos = (res.data.camposFaltando || []).filter(c => c !== 'email_confirmado');
      if (campos.length > 0) {
        setCamposFaltando(campos);
        setShow(true);
        return false;
      }
      return true;
    } catch { return true; }
  }, []);

  const salvar = async (clienteId) => {
    if (!form.endereco || !form.cep || !form.cidade || !form.estado) return;
    setSaving(true);
    try {
      const data = { ...form };
      if (data.cpf_cnpj) { data.cnpj = data.cpf_cnpj; delete data.cpf_cnpj; }
      else delete data.cpf_cnpj;
      await cadastroAPI.completar(clienteId, data);
      setShow(false);
      setCamposFaltando([]);
      toast.success('Cadastro atualizado!');
      return true;
    } catch { toast.error('Erro ao salvar'); return false; }
    finally { setSaving(false); }
  };

  const inputClass = darkMode ? 'bg-zinc-800 border-zinc-700 text-white' : 'bg-white border-gray-300 text-gray-900';
  const labelClass = `block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`;

  const modal = show ? (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setShow(false)}>
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      <div className={`relative w-full max-w-md rounded-2xl p-6 ${darkMode ? 'bg-zinc-900' : 'bg-white'}`} onClick={e => e.stopPropagation()}>
        <h3 className={`text-lg font-bold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Complete seu cadastro</h3>
        <p className={`text-sm mb-4 ${darkMode ? 'text-zinc-400' : 'text-gray-500'}`}>Preencha os dados abaixo para continuar</p>
        <div className="space-y-3">
          {camposFaltando.includes('cpf_cnpj') && (
            <div>
              <label className={labelClass}>CPF ou CNPJ *</label>
              <input type="text" placeholder="000.000.000-00" value={form.cpf_cnpj} onChange={e => setForm({...form, cpf_cnpj: e.target.value.replace(/\D/g,'')})}
                className={`w-full rounded-lg py-2 px-3 text-sm border ${inputClass}`} />
            </div>
          )}
          <div>
            <label className={labelClass}>Endereço *</label>
            <input type="text" placeholder="Rua das Flores, 123" value={form.endereco} onChange={e => setForm({...form, endereco: e.target.value})}
              className={`w-full rounded-lg py-2 px-3 text-sm border ${inputClass}`} />
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div>
              <label className={labelClass}>CEP *</label>
              <input type="text" placeholder="01234567" maxLength={8} value={form.cep} onChange={e => setForm({...form, cep: e.target.value.replace(/\D/g,'')})}
                className={`w-full rounded-lg py-2 px-3 text-sm border ${inputClass}`} />
            </div>
            <div>
              <label className={labelClass}>Cidade *</label>
              <input type="text" value={form.cidade} onChange={e => setForm({...form, cidade: e.target.value})}
                className={`w-full rounded-lg py-2 px-3 text-sm border ${inputClass}`} />
            </div>
            <div>
              <label className={labelClass}>UF *</label>
              <input type="text" placeholder="SP" maxLength={2} value={form.estado} onChange={e => setForm({...form, estado: e.target.value.toUpperCase()})}
                className={`w-full rounded-lg py-2 px-3 text-sm border ${inputClass}`} />
            </div>
          </div>
        </div>
        <div className="flex gap-3 mt-5">
          <button onClick={() => setShow(false)} className={`flex-1 py-2 rounded-lg text-sm font-medium ${darkMode ? 'bg-zinc-800 text-zinc-300' : 'bg-gray-100 text-gray-700'}`}>Cancelar</button>
          <button onClick={() => { const u = JSON.parse(localStorage.getItem('user') || '{}'); salvar(u.cliente_id); }}
            disabled={saving || !form.endereco || !form.cep || !form.cidade || !form.estado}
            className="flex-1 py-2 rounded-lg text-sm font-semibold text-white bg-gradient-to-r from-orange-500 to-orange-600 disabled:opacity-50">
            {saving ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </div>
    </div>
  ) : null;

  return (
    <CadastroContext.Provider value={{ verificarEAbrir, modal }}>
      {children}
      {modal}
    </CadastroContext.Provider>
  );
};
